export function observeCustomElement(
  selector: string,
  onAdd: (element: HTMLElement) => any,
  onRemove?: (element: HTMLElement) => any
) {
  if ((window as any)[`sellwild${selector}`]) return;
  (window as any)[`sellwild${selector}`] = true;
  customElements.define(
    selector,
    class extends HTMLElement {
      connectedCallback() {
        if (this.isConnected) {
          this.id = this.id || `${selector}-${randomId()}`;
          onAdd(this);
        }
      }
      disconnectedCallback() {
        if (onRemove) {
          onRemove(this);
        }
      }
    }
  );
}

function randomId(): string {
  const uint32 = window.crypto.getRandomValues(new Uint32Array(1))[0];
  return uint32.toString(16);
}
